function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj; }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }); } return _typeof(obj); }

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import Component from 'vue-class-component';
import { VueComponent, guid } from '@progress/kendo-vue-common';
import { Popup } from '@progress/kendo-vue-popup';
import { ColumnMenuContent } from './ColumnMenuContent';
/**
 * @hidden
 */

var ColumnMenu =
/** @class */
function (_super) {
  __extends(ColumnMenu, _super);

  function ColumnMenu() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.show = false;
    _this.blurTimeout = undefined;
    return _this;
  }

  ColumnMenu.prototype.created = function () {
    this._anchor = guid();
  };

  ColumnMenu.prototype.blur = function () {
    var _this = this;

    clearTimeout(this.blurTimeout);
    this.blurTimeout = setTimeout(function () {
      _this.closeMenu();
    }, 200);
  };

  ColumnMenu.prototype.focus = function () {
    clearTimeout(this.blurTimeout);
  };

  ColumnMenu.prototype.anchorClick = function () {
    this.show = !this.show;
    this.$nextTick(function () {
      this._content = this.$refs.content;

      if (this.show && this._content) {
        this._content.focus();
      }
    });
  };

  ColumnMenu.prototype.closeMenu = function () {
    this.show = false;
  };

  ColumnMenu.prototype.sortChange = function (newDescriptor, e) {
    this.$emit('sortchange', newDescriptor, e);
  };

  ColumnMenu.prototype.filterChange = function (newDescriptor, e) {
    this.$emit('filterchange', newDescriptor, e);
  };
  /**
   * @hidden
   */
  // @ts-ignore


  ColumnMenu.prototype.render = function (h) {
    var renderTemplate = this.$props.render;
    return h("div", {
      style: {
        display: 'inline'
      }
    }, [h("div", {
      style: {
        display: 'inline',
        position: 'absolute',
        cursor: 'pointer',
        right: '5px'
      },
      ref: this._anchor,
      on: {
        "click": this.anchorClick
      }
    }, [h("span", {
      "class": 'k-icon k-i-more-vertical'
    })]), h(Popup, {
      attrs: {
        anchor: this._anchor,
        show: this.show
      }
    }, [h("div", {
      ref: 'content',
      "class": 'k-grid-columnmenu-popup',
      attrs: {
        tabIndex: 0
      },
      on: {
        "focusout": this.blur,
        "focusin": this.focus
      },
      style: {
        outline: 'none'
      }
    }, [h(ColumnMenuContent, {
      attrs: {
        column: this.$props.column,
        sortable: this.$props.sortable,
        sort: this.$props.sort,
        filter: this.$props.filter,
        filterable: this.$props.filterable,
        render: renderTemplate
      },
      on: {
        "closemenu": this.closeMenu,
        "sortchange": this.sortChange,
        "filterchange": this.filterChange
      }
    })])])]);
  };

  ColumnMenu = __decorate([Component({
    props: {
      column: Object,
      sortable: [Boolean, Object],
      sort: {
        type: Array
      },
      filter: Object,
      filterable: Boolean,
      render: [Boolean, String, Function, Object]
    }
  })], ColumnMenu);
  return ColumnMenu;
}(VueComponent);

export { ColumnMenu };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-vue-grid/dist/es/columnMenu/ColumnMenu.js
// module id = null
// module chunks = 